'use client'

import React from 'react'

import {
  AnalyticsEntityType,
  AnalyticsSource,
  NestableAnalyticsProvider,
} from '@b-stock/fe-core/bstock-react'

import { useAnalyticsScreenName } from '@/components/globalHeader/useAnalyticsScreenName'

export const HeaderAnalyticsProvider = ({
  hasHomeIntent,
  pathname,
  children,
}: {
  pathname: string | null
  hasHomeIntent: boolean
  children: React.ReactNode
}) => {
  const screenName = useAnalyticsScreenName({
    pathname,
    hasHomeIntent,
  })
  return (
    <NestableAnalyticsProvider
      value={{
        screenName,
        global_header_2026_redesign_variant: 'variant_a',
        source: AnalyticsSource.HOME_PORTAL,
        entityType: AnalyticsEntityType.BUYER,
      }}
    >
      {children}
    </NestableAnalyticsProvider>
  )
}
